import { useSelector } from 'react-redux';

import { SportIds } from 'constants/app';
import { BettingTypes } from 'constants/markets';
import { getEnableFancyMarketsViewOnCricket, getEnableLineMarketsBranding } from 'redux/modules/appConfigs/selectors';
import { getIsFancyViewEnabled } from 'redux/modules/competitions/selectors';
import { BettingType } from 'types/markets';

export default function useLineAndFancyBranding({
  sportId,
  bettingType,
  isFancyView = false
}: {
  sportId: string;
  bettingType: BettingType | string | null;
  isFancyView?: boolean;
}) {
  const isCricket = sportId === SportIds.CRICKET;

  const enableLineMarketsBranding = useSelector(getEnableLineMarketsBranding);
  const enableFancyMarketsViewOnCricket = useSelector(getEnableFancyMarketsViewOnCricket);
  const isFancyViewEnabled = useSelector(getIsFancyViewEnabled); // this works only if user navigated to fancy market (through navigation)

  const isLineMarket = bettingType === BettingTypes.LINE;
  const isFancyBranding =
    isCricket && enableFancyMarketsViewOnCricket && isLineMarket && (isFancyViewEnabled || isFancyView);
  const isLineBranding = isLineMarket && enableLineMarketsBranding && !isFancyBranding;

  return {
    isFancyBranding,
    enableLineMarketsBranding,
    enableFancyMarketsViewOnCricket,
    isCricket,
    isLineMarket,
    isLineBranding,
    isFancyView: isFancyViewEnabled
  };
}
